import { z } from 'zod/v4'

export const CreateFieldDefinitionNormalizationSchema = z.object({
  handle: z.string(),
  sortOrder: z.number().optional().nullable(),
  arguments: z.unknown().optional().nullable(),
})

export const GetFieldDefinitionNormalizationSchema = z.object({
  handle: z.string(),
  sortOrder: z.number().optional().nullable(),
  arguments: z.unknown().optional().nullable(),
})

export const NumberRoundArgsSchema = z.object({
  precision: z.number().int().min(0).optional(),
  mode: z.enum(['round', 'ceil', 'floor']).optional(),
})

export type NumberRoundArgs = z.infer<typeof NumberRoundArgsSchema>
